interface PagingIndicatorProps {
  length: number
  pageStart: number
  pageEnd: number
}

function PagingIndicator({ length, pageStart, pageEnd }: PagingIndicatorProps) {
  return (
    <div className='flex justify-start text-xs text-[#666666]'>
      {pageEnd === 0 ? null : `${pageStart + 1}～${pageEnd}件目を表示（全${length}件中）`}
    </div>
  )
}

export default PagingIndicator
